<template>
  <PMain v-model="themeData" :dataKey="key">
    <v-row>
      <v-col> Clearing All </v-col>
    </v-row>
  </PMain>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PMain from "../components/PMain.vue";
import comminMixin from "../mixins/common";

export default {
  mixins: [comminMixin],
  data: () => ({
    key: "redirect",
    themeData: [],
    agree: false,
    dialogSuccess: false,
    collapse: {},
    editable: false,
    productRemarkActive: {},
    orderData: {
      order_remark: null,
    },

    willExpiresIn: null,
    timer: null,
  }),
  components: {
    PMain,
  },
  async mounted() {
    this.cartClearAll();
    this.sessionClearAll();
    this.$router.push('/');
  },
  methods: {
    ...mapActions({
      cartClearAll: "cart/clearAll",
      sessionClearAll: "session/clearAll",
    }),
  },
  watch: {

  },
  computed: {
    nextUrl() {
      return `/table/${this.tableId}`;
    },
  },
};
</script>
